module.exports = __webpack_public_path__ + "01b263b3ce7c5c3c21cee8a83a746a8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/profile/perfil/images/avatar_7.png
// module id = 386
// module chunks = 0